export default "__VITE_ASSET__CB7IJyMh__"